module.exports = __webpack_public_path__ + "static/media/19.cd854a8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Charities/brands/19.jpg
// module id = 589
// module chunks = 0